export const TOS_APP_PERMISSION = 'Bxt:tos';

// Terms and Conditions
export const READ_TNC_PERMISSION = 'Bxt:r:ApTnc';
export const CHECK_TNC_PERMISSION = 'Bxt:ck:ApTnc';
export const SUBMIT_TNC_PERMISSION = 'Bxt:u:ApTnc';

// User config & profile
export const GET_USER_CONFIG_PERMISSION = 'Bxt:r:cfg';
export const GET_USER_PROFILE_PERMISSION = 'Bxt:R:APUsrPrfl';

// Booking in Advance
export const CREATE_BOOKING_PERMISSION = 'Bxt:U:NHldBk';
export const GET_SEATMAP_PERMISSION = 'Bxt:R:StMp';

// Booking in Advance - Allow to create reservation / hold booking
export const CREATE_HOLD_BOOKING_PERMISSION = 'Bxt:U:HldBk';

// Booking in Advance - Allow to book on behalf other agent
export const BOOK_ON_BEHALF_PERMISSION = 'Bxt:C:BkOnBhf';
export const GET_AGENT_LIST_PERMISSION = 'Bxt:R:AgntLst';

// Go Show Booking
export const CREATE_GOSHOW_BOOKING_PERMISSION = 'Bxt:U:GShRes';
export const GET_GOSHOW_BOOKING_FORM_PERMISSION = 'Bxt:R:GSBkFrm';

// Transaction List
export const GET_TRANSACTION_LIST_PERMISSION = 'Bxt:R:TrxList';
export const ISSUE_RESERVATION_PERMISSION = 'Bxt:U:AppIssue';
export const CANCEL_RESERVATION_PERMISSION = 'Bxt:U:AppCncl';
export const CANCEL_ISSUANCE_PERMISSION = 'Bxt:U:AppCnclIssued';

// Pax Manifest
export const GET_PAX_MANIFEST_LIST_PERMISSION = 'Bxt:R:EPxMnf';
export const GET_PAX_MANIFEST_DETAIL_PERMISSION = 'Bxt:U:EDwlPxMnf';
export const VERIFY_ON_PAX_MANIFEST_PERMISSION = 'Bxt:U:AVerPxMnf';
